import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Link as RouterLink } from 'react-router-dom'
import './Footer.css'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import { useSelector } from 'react-redux'
import { RootState } from '../reducers/index';

const Footer = () => {

  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth)

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className="main-footer"
    >
      <Grid
        item
        container
        justifyContent={isAuthenticated ? "space-around" : "space-between"}
      >
        {!isAuthenticated && (
          <Grid item>
            <Grid container direction="column">
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  English teaching
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1" paragraph>
                  <RouterLink to="/teachers/register-teacher">
                    Become a teacher
                  </RouterLink>
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1" paragraph>
                  <RouterLink to="/teachers/how-to-teach">
                    How to teach
                  </RouterLink>
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1" paragraph>
                  <RouterLink to="/teachers/how-to-get-paid">
                    How to get paid
                  </RouterLink>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}

        {!isAuthenticated && (
          <Grid item>
            <Grid container direction="column">
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  Học tiếng Anh
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1" paragraph>
                  <RouterLink to="/login">
                    Đăng ký tài khoản học sinh
                  </RouterLink>
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1" paragraph>
                  <RouterLink to="/student/how-to-study">
                    Hướng dẫn cách học
                  </RouterLink>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}

        {!isAuthenticated && (
          <Grid item>
            <Grid container direction="column">
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  For admins
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1" paragraph>
                  <RouterLink to="/admin/login">Login admin</RouterLink>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}

        {isAuthenticated && user && user["role"] === "teacher" && (
          <Grid item>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <Typography variant="h6">Information</Typography>
              </Grid>

              <Grid item>
                <Typography variant="body1" paragraph>
                  <RouterLink to="/teachers/how-to-teach">
                    How to teach
                  </RouterLink>
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="body1" paragraph>
                  <RouterLink to="/teachers/how-to-get-paid">
                    How to get paid
                  </RouterLink>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}

        {isAuthenticated && user && user["role"] === "user" && (
          <Grid item>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <Typography variant="h6">Thông tin thêm</Typography>
              </Grid>

              <Grid item>
                <RouterLink to="/student/how-to-study">
                  Hướng dẫn cách học
                </RouterLink>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid item>
          <Grid container direction="column">
            <Grid item>
              <Typography variant="h6">Liên hệ:</Typography>
            </Grid>
            <Grid
              item
              container
              alignItems="center"
              style={{ marginBottom: "1.5em" }}
            >
              <Grid item>
                <EmailIcon />
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  &nbsp;<strong>Email: </strong>youspeak.service@gmail.com
                </Typography>
              </Grid>
            </Grid>
            <Grid
              item
              container
              alignItems="center"
              style={{ marginBottom: "1.5em" }}
            >
              <Grid item>
                <PhoneIcon />
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  &nbsp;<strong>Hotline & Zalo: </strong>0788 723 027
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item style={{ marginBottom: "1em" }}>
        <Typography variant="body1">
          &copy;{new Date().getFullYear()} YouSpeak
        </Typography>
      </Grid>
    </Grid>
  );
}

export default Footer
